"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomAddress = exports.ZERO_ADDRESS = exports.toAddress = void 0;
var binary_1 = require("./binary");
function toAddress(value) {
    var hex;
    if (value.startsWith("0x")) {
        hex = value.substring(2).toLowerCase();
    }
    else {
        hex = value.toLowerCase();
    }
    var re = /[0-9a-f]{40}/g;
    if (re.test(hex)) {
        return "0x" + hex;
    }
    else {
        throw new Error("not an address: " + value);
    }
}
exports.toAddress = toAddress;
exports.ZERO_ADDRESS = toAddress("0x0000000000000000000000000000000000000000");
function randomAddress() {
    return toAddress((0, binary_1.randomBinary)(20));
}
exports.randomAddress = randomAddress;
